export default {"src":"/_next/static/media/Success.ba90b479.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};